module.exports = __webpack_public_path__ + "static/media/logo.d9b2e27b.png";